export const getNavigationType = (): NavigationTimingType => {
	const navEntries = performance.getEntriesByType('navigation')
	const navEntry = navEntries[0] as PerformanceNavigationTiming | undefined
	return navEntry?.type ?? 'navigate'
}
